import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
//
import { store } from '../store';
// utils
import { LocalStorage } from '../utils/storage';
// types
import {LANGUAGE, I18_NEXT_LNG} from "../store/types";
// store
import { searchSysLanguages } from '../store/actions/userActions';

import deJSON from './translations/de';
import enJSON from './translations/en';
import esJSON from './translations/es';
import frJSON from './translations/fr';
import aeJSON from './translations/ae';
import zhJSON from './translations/zh';
import twJSON from './translations/tw';



const resources = {
    zh_CN: { translation: zhJSON },
    zh_TW: { translation: twJSON },
    en_US: { translation: esJSON },
    en_ES: { translation: enJSON },
    de: { translation: deJSON },
    fr: { translation: frJSON },
    ae: { translation: aeJSON },
};

i18n
  // .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    // lng: LANGUAGE.cn,
    // fallbackLng: LANGUAGE.cn,
    lng: LocalStorage.get(I18_NEXT_LNG) || LANGUAGE.tw,
    fallbackLng: LocalStorage.get(I18_NEXT_LNG) || LANGUAGE.tw,
    debug: true,
    // resources,
    keySeparator: false,
    react: {
      useSuspense: true
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
      format: (value, format, lng) => {
        // if (value instanceof Date) {
        //   return DateTime.fromJSDate(value)
        //     .setLocale(lng)
        //     .toLocaleString(DateTime[format]);
        // }
        return value;
      }
    },
    detection: {
      caches: ['localStorage', 'sessionStorage', 'cookie']
    },
    partialBundledLanguages: true,
    backend: {
      loadPath: '/locales/{{lng}}.json',
      request: async (options, url, payload, callback) => {
        try {
          const lang = LocalStorage.get(I18_NEXT_LNG);
          if (!lang || ['undefined'].includes(lang)) {
            LocalStorage.set(I18_NEXT_LNG, LANGUAGE.tw);
          }
          const json = await store.dispatch(searchSysLanguages(LocalStorage.get(I18_NEXT_LNG) || LANGUAGE.tw));
          callback(null, { status: 200, data: json });
        } catch (err) {
          callback(err, { status: 500 });
        }
      }
    }
    /* backend: {
      loadPath: () => '/i18n/translation/{{lng}}/.json',
      allowMultiLoading: false,
      crossDomain: false,
      withCredentials: false,
      overrideMimeType: false,
    }, */
  });

export default i18n;
